<template>
  <div
  v-if="!isFrame"
    @click="toggleDescription"
    class="cursor-pointer relative overflow-hidden rounded-xl bg-gradient-to-br from-gray-900 to-gray-800 shadow-xl transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl"
  >
    <!-- Result Badge -->
    <div
      v-if="showResult"
      :class="[
        'absolute right-0 top-4 z-10 px-6 py-1 text-sm font-bold uppercase tracking-wider text-white shadow-lg',
        resultClass
      ]"
      style="clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%)"
    >
      {{ match.betResult }}
    </div>

    <div class="p-6">
      <!-- Header -->
      <div class="mb-4">
        <div class="text-xs text-gray-400">{{ formattedDate }}</div>

        <!-- Обёртка для иконки и названия события -->
        <div class="flex items-center gap-2 mt-1">
          <!-- Показываем иконку, если найдена -->
           <img   class="w-5 h-5" v-if="match.sport == 'esports_dota2'" src="https://img.icons8.com/?size=100&id=61898&format=png&color=ffffff" alt="">
           <img    class="w-5 h-5" v-else-if="match.sport == 'esports_csgo'" src="https://img.icons8.com/?size=100&id=0zCSPyEKiaTL&format=png&color=ffffff" alt="">

           <img
            v-if="leagueIcon && match.sport !== 'esports_csgo' && match.sport !== 'esports_dota2' "
            :src="leagueIcon"
            alt="League Icon"
            class="w-5 h-5"
          />
          <h2 class="text-xl font-bold text-white">
            {{ match.eventName }}
          </h2>
        </div>
      </div>

      <!-- Match Info -->
      <div class="mb-6 grid gap-3">
        <div class="flex items-center justify-between">
          <div class="text-sm text-gray-300">
            Forecast:
            <span class="font-medium text-emerald-400">{{ match.forecast }}</span>
          </div>
          <div v-if="match.expectedRoi" class="flex items-center gap-2 bg-blue-900/20 px-2 py-0.5 rounded-md">
            <div class="h-2 w-2 rounded-full bg-blue-500 animate-pulse"></div>
            <span
              style="white-space: nowrap;"
              class="text-[12px] font-medium text-blue-400"
            >
              {{ match.expectedRoi }} ROI
            </span>
          </div>
        </div>
       

        <div class="text-sm text-gray-300">
          Coefficient:
          <span class="font-medium text-amber-400"
            >{{ match.coefficient }}</span
          >
        </div>
        <div class="description-container">
          <p class="text-sm text-gray-400">
            <span>{{ truncatedDescription }}</span>
            <span
              v-if="isDescriptionExpanded"
              class="description-expanded"
              >{{ remainingDescription }}</span
            >
          </p>
        </div>
      </div>
  
      <span class="text-xs text-blue-400 font-medium mt-auto">Read more</span>
       <!-- Scores -->
       <div v-if="match.scores?.length" 
           :class="[
             'mt-4 rounded-lg bg-gray-800/50 p-4',
             match.league === 'basketball_nba' ? 'flex items-center justify-center gap-4' : 'flex items-center justify-between'
           ]">
        
        <!-- Basketball Layout -->
        <template v-if="match.league === 'basketball_nba'">
          <div class="text-center">
            <div class="mb-1 text-sm text-gray-400">{{ match.scores[0].name }}</div>
            <div class="text-2xl font-bold text-white">{{ match.scores[0].score }}</div>
          </div>
          <div class="text-2xl font-light text-gray-600">vs</div>
          <div class="text-center">
            <div class="mb-1 text-sm text-gray-400">{{ match.scores[1].name }}</div>
            <div class="text-2xl font-bold text-white">{{ match.scores[1].score }}</div>
          </div>
        </template>

        <!-- Football/Soccer Layout -->
        <template v-else>
          <div class="text-center">
            <div class="mb-1 text-sm text-gray-400">{{ match.scores[0].name }}</div>
            <div class="text-2xl font-bold text-white">{{ match.scores[0].score }}</div>
          </div>
          <div class="text-2xl font-light text-gray-600">vs</div>
          <div class="text-center">
            <div class="mb-1 text-sm text-gray-400">{{ match.scores[1].name }}</div>
            <div class="text-2xl font-bold text-white">{{ match.scores[1].score }}</div>
          </div>
        </template>
      </div>
    </div>
  </div>
  <div
  v-else
    @click="toggleDescription"
    class="cursor-pointer relative overflow-hidden rounded-xl bg-gradient-to-br from-gray-900 to-gray-800 shadow-xl transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl"
  >
    <!-- Result Badge -->
    <div
      v-if="showResult"
      :class="[
        'absolute right-0 top-4 z-10 px-6 py-1 text-sm font-bold uppercase tracking-wider text-white shadow-lg',
        resultClass
      ]"
      style="clip-path: polygon(10% 0%, 100% 0%, 100% 100%, 0% 100%)"
    >
      {{ match.betResult }}
    </div>

    <div class="px-6 py-4">
      <!-- Header -->
      <div class="">
        <div class="text-xs text-gray-400">{{ formattedDate }}</div>

        <!-- Обёртка для иконки и названия события -->
        <div class="flex items-center gap-2 mt-1">
          <!-- Показываем иконку, если найдена -->
           <img   class="w-5 h-5" v-if="match.sport == 'esports_dota2'" src="https://img.icons8.com/?size=100&id=61898&format=png&color=ffffff" alt="">
           <img    class="w-5 h-5" v-else-if="match.sport == 'esports_csgo'" src="https://img.icons8.com/?size=100&id=0zCSPyEKiaTL&format=png&color=ffffff" alt="">

           <img
            v-if="leagueIcon && match.sport !== 'esports_csgo' && match.sport !== 'esports_dota2' "
            :src="leagueIcon"
            alt="League Icon"
            class="w-5 h-5"
          />
          <h2 class="text-xl font-bold text-white">
            {{ match.eventName }}
          </h2>
        </div>
      </div>

      <!-- Match Info -->
      <div class=" flex gap-3">
        <div class="flex items-center justify-between">
          <div class="text-sm text-gray-300">
            Forecast:
            <span class="font-medium text-emerald-400">{{ match.forecast }}</span>
          </div>
          
        </div>
       

        <div class="text-sm text-gray-300">
          Coefficient:
          <span class="font-medium text-amber-400"
            >{{ match.coefficient }}</span
          >
        </div>
       
      </div>
  
     
       <!-- Scores -->
       
    </div>
  </div>
</template>

<script setup>
import { computed, ref, defineProps } from 'vue'
import { useRoute } from 'vue-router'
import { Leagues } from './leagues';
// Список лиг и их групп

const availableLeagues = Leagues

const props = defineProps({
  match: {
    type: Object,
    required: true
  }
})

const route = useRoute()
const isDescriptionExpanded = ref(false)

// Функция переключения состояния описания
const toggleDescription = () => {
  isDescriptionExpanded.value = !isDescriptionExpanded.value
}

// Получаем данные лиги
const leagueData = computed(() => {
  return availableLeagues.find(league => league.key === props.match.league) || {}
})

// const leagueTitle = computed(() => leagueData.value.title || 'Unknown League')

// Подбираем иконку в зависимости от группы
const leagueIcon = computed(() => {
  const group = leagueData.value.group?.toLowerCase()

  const iconMap = {
  'american football': 'https://img.icons8.com/?size=100&id=9775&format=png&color=000000',
  "NRL":"https://img.icons8.com/?size=100&id=9775&format=png&color=ffffff", // NFL
  'baseball': 'https://img.icons8.com/?size=100&id=60038&format=png&color=ffffff', // MLB
  'basketball': 'https://img.icons8.com/?size=100&id=fCa2W359XPO3&format=png&color=ffffff', // NBA
  'golf': 'https://img.icons8.com/?size=100&id=60447&format=png&color=ffffff', // Golf
  'ice hockey': 'https://img.icons8.com/?size=100&id=pg0oNK0iG0gx&format=png&color=ffffff', // NHL
  'rugby league': 'https://img.icons8.com/?size=100&id=9775&format=png&color=ffffff', // Rugby League
  'rugby union': 'https://img.icons8.com/?size=100&id=9775&format=png&color=ffffff', // Rugby Union
  'soccer': 'https://img.icons8.com/?size=100&id=61032&format=png&color=ffffff', // Football (Soccer)
  'tennis': 'https://img.icons8.com/?size=100&id=62451&format=png&color=ffffff', // Tennis
  'mma': 'https://img.icons8.com/?size=100&id=Q47LCMLRs42t&format=png&color=ffffff', // MMA
  'boxing': 'https://img.icons8.com/?size=100&id=566&format=png&color=ffffff', // Boxing
  'cricket': 'https://img.icons8.com/?size=100&id=56061&format=png&color=ffffff', // Cricket
  'formula 1': 'https://img.icons8.com/?size=100&id=62306&format=png&color=ffffff', // Formula 1
  'motorsport': 'https://img.icons8.com/?size=100&id=62819&format=png&color=ffffff', // Motorsport
  'cycling': 'https://img.icons8.com/?size=100&id=50155&format=png&color=ffffff', // Cycling
  'csgo': 'https://img.icons8.com/?size=100&id=0zCSPyEKiaTL&format=png&color=ffffff', // eSports
  'dota': 'https://img.icons8.com/?size=100&id=61898&format=png&color=ffffff'
};


  return iconMap[group] || null
})

const formattedDate = computed(() => {
  const date = new Date(props.match.date)
  return date.toLocaleDateString('en-US', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  })
})

const showResult = computed(() => route.path.includes('/results'))

const resultClass = computed(() => {
  const result = props.match.betResult?.toLowerCase()
  return result === 'won' ? 'bg-green-600' : result === 'lost' ? 'bg-red-600' : 'bg-gray-600'
})
const isFrame = window.location.pathname.includes("frame")

const truncatedDescription = computed(() => props.match.description?.split('. ').slice(0, 2).join('. ') + '.' || '')
const remainingDescription = computed(() => props.match.description?.split('. ').slice(2).join('. ') || '')

</script>
